/* eslint-disable jsx-quotes */
import React, { Component } from 'react';

import Loader from '../loader-component/loader';
import SelectionQuestions from '../selection-questions/selection-questions';

import './manage-template-test.css';

class ManageTemplateTestPresentation extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            labelTest,
            maxDuration,
            percentual,
            handleChangeInput,
            handleSubmit,
            formReady,
            loading,
            showQuestions,
            handleShowQuestions,
            handleHandleQuestionsAdd,
            currentSelects,
            questionsAddeds,
            questionsRemoveds,
            checkDisableQuestionFn,
            amountQuestion,
            minOptions,
            maxOptions,
        } = this.props;

        return (
            <section className="container-manage-test">
                <h1>Gerenciar teste</h1>
                <form onSubmit={handleSubmit} className="content-form">
                    <div className="line">
                        <span className="field">
                            <label htmlFor="labelTest">Label</label>
                            <input
                                id="labelTest"
                                name="labelTest"
                                value={labelTest}
                                onChange={({ target }) =>
                                    handleChangeInput(target)
                                }
                                type="text"
                            />
                        </span>
                        <span className="field field-amount-questions">
                            <label htmlFor="amountQuestion">
                                Quantidade de questões
                            </label>
                            <input
                                id="amountQuestion"
                                name="amountQuestion"
                                type="number"
                                value={amountQuestion}
                                onChange={({ target }) =>
                                    handleChangeInput(target)
                                }
                                min={1}
                                max={256}
                            />
                        </span>
                        <span className="field field-max-duration">
                            <label htmlFor="maxDuration">
                                Duração máxima em minutos
                            </label>
                            <input
                                id="maxDuration"
                                name="maxDuration"
                                type="number"
                                value={maxDuration}
                                onChange={({ target }) =>
                                    handleChangeInput(target)
                                }
                                min={5}
                                max={480}
                            />
                        </span>
                    </div>
                    <div className="line">
                        <span className="field">
                            <label htmlFor="maxOptions">
                                Quantidade máxima de opções
                            </label>
                            <input
                                disabled={true}
                                id="maxOptions"
                                type="number"
                                min={2}
                                max={20}
                                value={maxOptions}
                                onChange={({ target }) =>
                                    handleChangeInput(target)
                                }
                                name="maxOptions"
                            />
                        </span>
                        <span className="field ">
                            <label htmlFor="minOptions">
                                Quantidade mínima de opções
                            </label>
                            <input
                                disabled={true}
                                id="minOptions"
                                type="number"
                                min={2}
                                max={maxOptions}
                                value={minOptions}
                                onChange={({ target }) =>
                                    handleChangeInput(target)
                                }
                                name="minOptions"
                            />
                        </span>
                        <span className="field">
                            <label htmlFor="percentual">
                                Porcentagem necessária para aprovação
                            </label>
                            <input
                                id="percentual"
                                type="number"
                                min={0}
                                max={100}
                                value={percentual}
                                onChange={({ target }) =>
                                    handleChangeInput(target)
                                }
                                name="percentual"
                            />
                        </span>
                    </div>
                    <button
                        onClick={() => handleShowQuestions(showQuestions)}
                        className="add-questions-button"
                        type="button"
                    >
                        {!showQuestions
                            ? 'Selecionar questões'
                            : 'Ocultar questões'}
                    </button>
                    {showQuestions && (
                        <div className="content-questions">
                            <SelectionQuestions
                                onChangeSelecteds={handleHandleQuestionsAdd}
                                questionsAlreadySelecteds={currentSelects}
                                checkDisableQuestionFn={checkDisableQuestionFn}
                            />
                        </div>
                    )}
                    <span className="span-question">
                        {currentSelects.length} questões selecionadas
                    </span>
                    <span className="span-question">
                        {questionsAddeds.length} novas questões adicionadas
                    </span>
                    <span className="span-question">
                        {questionsRemoveds.length} questões removidas
                    </span>
                    <button
                        disabled={!formReady}
                        className={
                            formReady
                                ? 'save-button'
                                : 'save-button disabled-btn'
                        }
                        type="submit"
                    >
                        Atualizar
                    </button>
                    <button
                        className="cancelEdit"
                        type="buttton"
                    >
                        Voltar
                    </button>
                </form>
                {loading > 0 && (
                    <Loader
                        show={loading > 0 ? true : false}
                        message={'Carregando, por favor aguarde...'}
                    />
                )}
            </section>
        );
    }
}

export default ManageTemplateTestPresentation;



// WEBPACK FOOTER //
// ./src/components/manage-template-test/manage-template-test-presentation.js